/* Shared react-select theme: follows site light/dark vars (storefront). */
export const selectStyles = {
  control: (base, st) => ({
    ...base,
    background: 'var(--card)',
    borderColor: st.isFocused ? 'var(--primary)' : 'var(--border)',
    borderWidth: '1.5px',
    borderRadius: 12,
    minHeight: 46,
    boxShadow: 'none',
    '&:hover': { borderColor: 'var(--primary)' },
  }),
  menu: base => ({
    ...base,
    background: 'var(--card)',
    border: '1px solid var(--border)',
    borderRadius: 12,
    overflow: 'hidden',
    zIndex: 60,
  }),
  menuList: base => ({ ...base, background: 'var(--card)', padding: 4 }),
  option: (base, st) => ({
    ...base,
    background: st.isSelected ? 'var(--primary)' : st.isFocused ? 'var(--muted)' : 'transparent',
    color: st.isSelected ? 'var(--on-primary)' : 'var(--fg)',
    borderRadius: 8,
    cursor: 'pointer',
  }),
  singleValue: base => ({ ...base, color: 'var(--fg)' }),
  input: base => ({ ...base, color: 'var(--fg)' }),
  placeholder: base => ({ ...base, color: 'var(--muted-fg)' }),
  noOptionsMessage: base => ({ ...base, color: 'var(--muted-fg)' }),
  loadingMessage: base => ({ ...base, color: 'var(--muted-fg)' }),
};
